import { Loading } from '@components';
import AppConfig from '@config';
import { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Dialog, IconButton, Portal } from 'react-native-paper';
import ChekinWidget from './ChekinWidget';

const CHEKIN_DIALOG_CLOSE_DELAY_MS = 3000;

type ChekinDialogProps = {
  visible: boolean;
  companyId?: string;
  pmsReservationId?: string;
  onDismiss: () => void;
  onGuestRegistered?: (guest: unknown) => void;
};

export const ChekinDialog = ({
  visible,
  companyId,
  pmsReservationId,
  onDismiss,
}: ChekinDialogProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const isVisible = visible && !!companyId && !!pmsReservationId;

  const handleGuestRegistered = (_: unknown) => {
    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
      onDismiss();
    }, CHEKIN_DIALOG_CLOSE_DELAY_MS);
  };

  return (
    <Portal>
      <Dialog
        visible={isVisible}
        onDismiss={onDismiss}
        dismissable
        style={styles.dialog}>
        <View style={styles.header}>
          <IconButton
            icon="close"
            size={AppConfig.Styles.getAdjustedSize(25)}
            onPress={onDismiss}
          />
        </View>
        <Dialog.Content style={styles.content}>
          <View style={styles.widgetContainer}>
            {isVisible && (
              <ChekinWidget
                companyId={companyId}
                pmsReservationId={pmsReservationId}
                onGuestRegistered={handleGuestRegistered}
              />
            )}
          </View>
        </Dialog.Content>
        {isLoading && (
          <View style={styles.loadingOverlay}>
            <Loading />
          </View>
        )}
      </Dialog>
    </Portal>
  );
};

const styles = StyleSheet.create({
  dialog: {
    backgroundColor: 'white',
    display: 'flex',
    alignSelf: 'center',
    width: '95%',
    height: '95%',
  },
  header: {
    marginTop: 0,
    marginRight: 16,
    alignItems: 'flex-end',
  },
  content: {
    flex: 1,
    width: '100%',
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0,
  },
  widgetContainer: {
    flex: 1,
    width: '100%',
    paddingBottom: 43,
  },
  loadingOverlay: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    borderRadius: 43,
  },
});

export default ChekinDialog;
